import React, { useCallback, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useAppAuth } from '~/hooks/appAuth';
import { useSettings } from '~/hooks/settings';

import {
  Container,
  ContainerBackground,
  ContainerInfo,
  Logo,
  CompanyName,
  CompanyDescription,
  CompanyStatus,
  ContainerCompanyStatus,
  SignOut,
} from './styles';

interface Params {
  id: string;
}

interface HeaderProps {
  show?: boolean;
}

const Header: React.FC<HeaderProps> = ({ show = true }) => {
  const location = useLocation();
  const history = useHistory();

  const { company, loadCompany, loadTable } = useSettings();
  const { user, signOut } = useAppAuth();

  useEffect(() => {
    if (!company.uid) loadCompany();
  }, [loadCompany, company]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const tableId = query.get('table');

    if (tableId) {
      loadTable(tableId);
    }
  }, [location, loadTable]);

  const handleSignOut = useCallback(() => {
    signOut();

    history.push(`/${company.app_domain}`);
  }, [signOut, history, company]);

  return (
    <>
      {show && (
        <Container id="header" className="mb-3">
          {user && user.uid && (
            <SignOut onClick={handleSignOut}>
              <i className="bi bi-power" style={{ marginRight: 8 }} />
              Sair
            </SignOut>
          )}
          <ContainerBackground
            style={{
              background: 'url("https://img.magnific.com/fotos-gratis/pizza-recem-assada-na-mesa-de-madeira-rustica-gerada-por-ia_188544-24094.jpg")',
              backgroundPosition: '50% 38%',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              /*background: company.app_background
                ? `url('${company.app_background}')`
                : company.app_color,*/
            }}
          />
          <ContainerInfo>
            <Logo
              src={company.image}
              alt="logo"
              style={{
                width: 180,
                height: 180,
                borderRadius: company.logo_format === '1' ? '50%' : '',
              }}
            />
            <CompanyName>{company.fantasy}</CompanyName>
            {company.description && (
              <CompanyDescription>{company.description}</CompanyDescription>
            )}
            <ContainerCompanyStatus>
              <CompanyStatus opened={company.opened}>
                {company.opened ? 'Aberto' : 'Fechado'}
              </CompanyStatus>
            </ContainerCompanyStatus>
          </ContainerInfo>
        </Container>
      )}
    </>
  );
};

export default Header;
